import publicMutation from './publicMutation'
import userMutation from './userMutation'
import storeMutation from './storeMutation'
import orderMutation from './orderMutation'
import homeMutation from './homeMutation'

export default {
  ...publicMutation,
  ...userMutation,
  ...storeMutation,
  ...orderMutation,
  ...homeMutation,
}
